import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gtsHTMLTags',
  standalone: true,
})
export class GtsHtmlTagsPipe implements PipeTransform {
  transform(input: string): string {
    return input.replaceAll('titel>', 'h4>');
  }
}
